const LegendaryHeroes_Hazmat = [
  { name: "hazmat1", url: require("./jfhLegendary_003.jpg") },
  { name: "hazmat2", url: require("./jfhLegendary_004.jpg") },
  { name: "hazmat3", url: require("./jfhLegendary_005.jpg") },
  { name: "hazmat4", url: require("./jfhLegendary_006.jpg") },
];
export default LegendaryHeroes_Hazmat;
